/**
 * imp_uid로 iamport 인증 성공 후 모두싸인 서버로 보내주는 response 내 인증자 name이 최대 20자로 제한되어 보내집니다.
 * 실제 이름은 길이 제한 없이 displayName과 iamport 인증에 사용됩니다.
 * 모두싸인 서버 내 passValue 저장 및 인증 시, name에 최대 길이가 제한됩니다.
 * https://github.com/modusign/modusign-client/pull/7992
 */

export default function limitNameForAuth(name: string) {
  return name.substr(0, 20);
}
